import React, { useRef, useEffect } from 'react';
import { Download, ChevronDown, FileSpreadsheet, FileText } from 'lucide-react';
import './ExportDropdown.css';

export default function ExportDropdown({ show, onToggle, onExportExcel, onExportTXT, count }) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onToggle();
      }
    };

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show, onToggle]);

  return (
    <div className="export-dropdown" ref={dropdownRef}>
      {/* <button
        onClick={onToggle}
        className="export-dropdown__button"
      >
        <Download className="w-5 h-5" />
        <span>Exportar</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${show ? 'rotate-180' : ''}`} />
      </button> */}

      {show && (
        <div className="export-dropdown__menu">
          <button
            onClick={() => {
              onExportExcel();
              onToggle();
            }}
            className="export-dropdown__item"
          >
            <FileSpreadsheet className="w-5 h-5 text-green-600" />
            <div className="export-dropdown__item-text">
              <p className="export-dropdown__item-title">Excel (.xlsx)</p>
              <p className="export-dropdown__item-subtitle">Planilha formatada</p>
            </div>
          </button>

          <button
            onClick={() => {
              onExportTXT();
              onToggle();
            }}
            className="export-dropdown__item"
          >
            <FileText className="w-5 h-5 text-blue-600" />
            <div className="export-dropdown__item-text">
              <p className="export-dropdown__item-title">Texto (.txt)</p>
              <p className="export-dropdown__item-subtitle">Dados tabulados</p>
            </div>
          </button>

          <div className="export-dropdown__divider"></div>

          <div className="export-dropdown__footer">
            <p className="export-dropdown__count">
              {count} registro{count !== 1 ? 's' : ''} será{count !== 1 ? 'ão' : ''} exportado{count !== 1 ? 's' : ''}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
